import type { Place } from '~/places/places.types';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import { useZIndexSeries } from './useZIndexSeries.hook';
import { ZIndexedEntity } from './zIndexRanges';

type PlaceWithSearchId = Place & Readonly<{ searchId: PlacesSearchId }>;

export const placesSearchMarkersSubEntities = ['marker', 'circle', 'text'] as const;
type PlacesSearchMarkerZIndexSubEntity = typeof placesSearchMarkersSubEntities[number];
export type PlaceZIndex = { [key in PlacesSearchMarkerZIndexSubEntity]: number };

const idMapper = (w: PlaceWithSearchId) => `${w.searchId}-${w.id}`;

export const usePlacesSearchZIndexes = (places: ReadonlyArray<PlaceWithSearchId>) =>
  useZIndexSeries(() => ({
    orderedEntities: places,
    orderedSubEntities: placesSearchMarkersSubEntities,
    idMapper,
    zIndexedEntity: ZIndexedEntity.PlacesMarker,
  }), [places]).subEntityZIndexes;
